import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { Divider2 } from "@/ui2/atoms/Divider";
import { NoteActions } from "@/components/Common/Note/NoteActions";
import type { NoteDetail, UUID } from "@/core/types";

import { AccessingPHIDisclaimer } from "./AccessingPHIDisclaimer";
import { CosignRejectedAlert } from "./(cosignature)/CosignRejectedAlert";
import { getNoteBadgesContent } from "./NoteBadges";
import { getNoteMetaContent } from "./NoteMetaData";

type NoteActionsBarProps = {
  isEditable: boolean;
  isEditing: boolean;
  note: NoteDetail;
  patientId: UUID;
  setDraftNoteId: (id: UUID | null) => void;
  setIsEditing: (v: boolean) => void;
  setShowDeleteNotePopUp: (v: boolean) => void;
};

export function NoteActionsBar({
  isEditable,
  isEditing,
  note,
  patientId,
  setDraftNoteId,
  setIsEditing,
  setShowDeleteNotePopUp,
}: NoteActionsBarProps) {
  const isRejected = note.note_state === "rejected";
  const noteBadges = getNoteBadgesContent({ badgeSize: "md", note });
  const noteMeta = getNoteMetaContent({ note, showSignature: false });

  return (
    <DashboardCard2 className="tw:flex tw:p-5!" classNameChildren="tw:flex tw:flex-col tw:gap-4">
      <div className="tw:flex tw:flex-row tw:justify-between tw:gap-6">
        <AccessingPHIDisclaimer />

        <NoteActions
          isEditable={isEditable}
          isEditing={isEditing}
          note={note}
          patientId={patientId}
          setDraftNoteId={setDraftNoteId}
          setIsEditing={setIsEditing}
          setShowDeleteNotePopUp={setShowDeleteNotePopUp}
        />
      </div>

      {(noteBadges || noteMeta) && (
        <>
          <Divider2 />

          {isRejected ? (
            <div className="tw:flex tw:flex-col tw:gap-4">
              {/* TODO: Confirm this combination is possible */}
              {noteBadges && (
                <ul className="tw:flex tw:items-start tw:justify-start tw:gap-2 tw:lg:flex-row">
                  {noteBadges}
                </ul>
              )}

              <CosignRejectedAlert noteId={note.id} />
            </div>
          ) : (
            <ul className="tw:flex tw:items-start tw:justify-start tw:gap-2 tw:lg:flex-row">
              {noteBadges}
              {noteMeta}
            </ul>
          )}
        </>
      )}
    </DashboardCard2>
  );
}
